export default __webpack_public_path__ + "static/media/Tasset of Baleful Blood.2d435623.jpg";